export default __webpack_public_path__ + "static/media/icons-email.de77868a.svg";